export default __webpack_public_path__ + "static/media/wifi5Security.89b66de6.png";